export const userRequestsI18n = {
  en: {
    approveSelected: 'Approve Selected',
    denySelected: 'Deny Selected',
    approveUsers: 'Approve Users',
    approvedHistory: 'Approved History',
    deniedHistory: 'Denied History',
    pleaseConfirm: 'Please Confirm',
    approve: 'Approve',
    deny: 'Deny',
    yes: 'Yes',
    no: 'No',
    headers: {
      username: 'Username',
      fullName: 'Full Name',
      email: 'Email',
      phone: 'Phone Number',
      organization: 'Organization',
      role: 'Role',
      actions: 'Actions',
      note: 'Note'
    },
    info: {
      denyUserConfirm: 'Are you sure you want to deny this user request ?',
      includeDenyNote: 'If you like you could include a rejection note.',
      noteDisclamer: 'characters remaining',
      approveUserConfirm: 'Are you sure you want to approve this user request ?',
      approveUser: 'Approve User',
      denyUser: 'Deny User',
      userRequestDetail: 'Detail user request',
      approveUsersSelectedConfirm:'Are you sure you want to approve the selected user requests ?',
      denyUsersSelectedConfirm: 'Are you sure you want to deny the selected user requests ?'
    },
    success: {
      userApproved: 'User approved successfully',
      userDenied: 'User denied successfully'
    },
    errors: {
      userNoApproved: 'There was a problem approving the user',
      userNoDenied: 'There was a problem denying the user',
      couldNotFindUser: 'There was a problem trying to find the user'
    },
    details: {
      username: 'Username:',
      representOrg: 'Represent an Organization?',
      organizationName: 'Organization Name:',
      organizationType: 'Organization Type:',
      ein: 'EIN:',
      registeredEnterprice: 'Registered Enterprise:',
      address: 'Address:',
      city: 'City:',
      state: 'State/Province:',
      zipcode: 'Zip/Postal Code:',
      country: 'Country:',
      mainCategories: 'Main Categories:',
      websiteAddress: 'Website Address:',
      phoneNumber: 'Phone Number:',
      contactFullName: 'Contact Full Name:',
      email: 'Email Address:'
    }
  },
  es: {
    approveSelected: 'Aprobar seleccionados',
    denySelected: 'Denegar seleccionados',
    approveUsers: 'Aprobar Usuarios',
    approvedHistory: 'Historial de Aprobados',
    deniedHistory: 'Historial de Denegados',
    pleaseConfirm: 'Por favor confirma',
    approve: 'Aprobar',
    deny: 'Denegar',
    yes: 'Si',
    no: 'No',
    headers: {
      username: 'Nombre de usuario',
      fullName: 'Nombre completo',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      organization: 'Organización',
      role: 'Rol',
      actions: 'Acciones',
      note: 'Nota'
    },
    info: {
      denyUserConfirm: 'Está seguro de denegar esta creación de usuario ?',
      includeDenyNote: 'Si lo desea, puede incluir una nota de rechazo.',
      noteDisclamer: 'caracteres disponibles',
      approveUserConfirm: 'Está seguro de aprobar esta creación de usuario ?',
      approveUser: 'Aprobar usuario',
      denyUser: 'Denegar Usuario',
      userRequestDetail: 'Detalle de requerimiento de usuario',
      approveUsersSelectedConfirm: 'Está seguro de aprobar los usuarios seleccionados ?',
      denyUsersSelectedConfirm: 'Está seguro de denegar los usuarios seleccionados ?'
    },
    success: {
      userApproved: 'Usuario aprobado éxitosamente',
      userDenied: 'Usuario denegado éxitosamente',
    },
    errors: {
      userNoApproved: 'Hubo un problema aprobando el usuario',
      userNoDenied: 'Hubo un problema denegando el usuario',
      couldNotFindUser: 'Hubo un problema para encontrar el usuario'
    },
    details: {
      username: 'Nombre de Usuario:',
      representOrg: 'Representa a una Organización?',
      organizationName: 'Nombre de la Organización:',
      organizationType: 'Tipo de Organización:',
      ein: 'EIN:',
      registeredEnterprice: 'Empresa Registrada:',
      address: 'Dirección:',
      city: 'Ciudad:',
      state: 'Estado/Provincia:',
      zipcode: 'Código Postal:',
      country: 'País:',
      mainCategories: 'Categorías Principales:',
      websiteAddress: 'Dirección Web:',
      phoneNumber: 'Número Telefónico:',
      contactFullName: 'Nombre completo del contacto:',
      email: 'Correo Electrónico:'
    }
  }
};